import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Close from '@material-ui/icons/Close';
import Slider from '@material-ui/lab/Slider';
import Switch from '@material-ui/core/Switch';

import WaveVisualizer from './WaveVisualizer';
import PitchVisualizer from './PitchVisualizer';
import { getOptions } from '../../lib/optionsHelper';
import { slider_classes, grid_classes, switch_classes } from '../../lib/classNames';

class PitchDetector extends Component {
  static propTypes = {
    controller: PropTypes.object.isRequired,
    onNoteChanged: PropTypes.func.isRequired,
    onClose: PropTypes.func
  };

  constructor(props) {
    super(props);
    const { rmsReference } = getOptions();
    this.state = {
      micSourceEnabled: null,
      waveData: null,
      lastNote: null,
      instantaneousNote: null,
      // RMS level
      rmsReference: rmsReference
    };

    this.setupController();
    this.state.micSourceEnabled = this.props.controller.micSourceEnabled;
  }

  componentWillUnmount() {
    //this.teardownController();
  }

  setupController() {
    this.props.controller.params = {
      // questa forse si puo' eliminare? teniamo lo stato del microfono solo qui nelle opzioni?
      onMicrophoneStateChanged: enabled => {
        if(!enabled)return;
        // BLEAH. Mettere questa cosa nel posto giusto, in base a boh, chi lo sa...
        document.querySelectorAll('.Tutor-Option-paperScrollPaper')[0].classList.toggle('dark');
        this.setState({ micSourceEnabled: enabled });
      },
      onWaveChanged: this.onWaveChanged,
      onNoteChanged: note => {
        this.setState({ lastNote: note });
        if (this.props.onNoteChanged) this.props.onNoteChanged(note);
      }
    };
  }

  teardownController() {
    this.props.controller.params = {
      onMicrophoneStateChanged: null,
      onWaveChanged: null,
      onNoteChanged: null
    };
    if (this.props.controller.micSourceEnabled) this.props.controller.toggleMicrophone();
    if (this.props.onNoteChanged) this.props.onNoteChanged(null);
  }

  onWaveChanged = instantaneousNote => {
    this.setState({
      waveData: this.props.controller.dataArray,
      instantaneousNote: instantaneousNote
    });
  };

  rmsSliderChange = (event, value) => {
    this.setState({ rmsReference: value });
    localStorage.setItem('rmsReference', value);
    this.props.controller.optionChanged();
  };

  handleChange = event => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({ [name]: value });
    localStorage.setItem(name, value);
    this.props.controller.optionChanged();
  };


  render = () => {
    const { onClose } = this.props;
    const { waveData, rmsReference, micSourceEnabled} = this.state;

    return (
      <Grid
        className="pitch-detector"
        classes={grid_classes}
        container
        direction="row"
        justify="center"
        alignItems="stretch"
        spacing={40}
      >
        <Grid classes={grid_classes} item xs={10} container direction="column" justify="space-between" spacing={0}>
          <Grid item className="pitch-intro">
            <div className="pitch-left" />
            <div className="pitch-right">
              <button className="Tutor-Close" onClick={onClose}>
                <Close />
              </button>
            </div>
          </Grid>
          <Grid item className="Pitch-Mic-Enable">
            {micSourceEnabled ? 'Disattiva il microfono' : 'Attiva il microfono'}
            <Switch
              classes={switch_classes}
              name="enableMicSlider"
              checked={this.state.micSourceEnabled}
              onChange={this.props.controller.toggleMicrophone}
            />
            {this.state.micSourceEnabled ? null : (
              <div className="pitch-pres">
                La modalità TUTOR ti permette di verificare la tua
                <br />
                esecuzione.
                <br />
                Per attivare questa modalità è necessario attivare il
                <br />
                microfono del tuo computer.
              </div>
            )}
          </Grid>
          {micSourceEnabled && [
            <Grid
              key={1}
              item
              className="detect-area"
              classes={grid_classes}
              container
              direction="row"
              spacing={40}
            >
              {waveData && (
                <Grid className="detect-intro-cont" item xs={6}>
                  <div className="detect-intro">
                    <h2>Riconoscimento</h2>
                    Suona una nota con il tuo strumento.
                    <br />
                    Aumenta o diminuisci la soglia di rumore finché il sistema
                    <br />
                    non rivelerà la nota che stai eseguendo.
                  </div>
                  <div item="true">
                    <PitchVisualizer note={this.state.lastNote} verbose={false} />
                  </div>
                </Grid>
              )}
              <Grid item xs={6} container direction={'row'}>
                <Slider
                  classes={slider_classes}
                  value={rmsReference}
                  aria-labelledby="label"
                  max={1}
                  min={0}
                  onChange={this.rmsSliderChange}
                />
                <WaveVisualizer waveData={waveData} rmsValue={rmsReference} />
              </Grid>
            </Grid>,
            <Grid key={2} item className="button-area" container direction="row" spacing={40}>
              <Grid className="pitch-mic-cont" item xs={6}>
                <div className="pitch-mic-intro">
                  <h2>Modalità Tutor</h2>
                  Quando sei pronto premi PLAY e inizia a suonare, il sistema
                  <br />
                  verificherà la correttezza della tua esecuzione. Quando hai
                  <br />
                  terminato premi HO FINITO e scopri come sei andato!
                </div>
              </Grid>
              <Grid className="pitch-mic-go" item xs={6}>
                <button className="big-button" onClick={onClose}>
                  Vai al brano
                </button>
              </Grid>
            </Grid>
          ]}
        </Grid>
      </Grid>
    );
  };
}

export default PitchDetector;
